import {uniqueId} from 'underscore';

window.__transloc__ = window.__transloc__ || {};
window.__transloc__.idle = window.__transloc__.idle || true;
window.__transloc__.idleTimeout = window.__transloc__.idleTimeout || 10;
window.__transloc__.pendingActions = window.__transloc__.pendingActions || [];
window.__transloc__.pendingRequests = window.__transloc__.pendingRequests || [];

const transloc = window.__transloc__;

let checkIdleTimeout;
const checkIdle = () => {
  if (transloc.pendingActions.length || transloc.pendingRequests.length) {
    window.clearTimeout(checkIdleTimeout);
    transloc.idle = false;
  } else {
    checkIdleTimeout = setTimeout(() => {
      transloc.idle = true;
    }, transloc.idleTimeout);
  }
};

export const startAction = (tag) => {
  const id = tag || uniqueId('action_');
  transloc.pendingActions = transloc.pendingActions.concat([id]);
  return {
    end: () => {
      const index = transloc.pendingActions.indexOf(id);
      transloc.pendingActions = transloc.pendingActions
        .slice(0, index)
        .concat(transloc.pendingActions.slice(index + 1));
      checkIdle();
    },
  };
};

export const startRequest = (url) => {
  const id = url || uniqueId('request_');
  transloc.pendingRequests = transloc.pendingRequests.concat([id]);
  return {
    end: () => {
      const index = transloc.pendingRequests.indexOf(id);
      transloc.pendingRequests = transloc.pendingRequests
        .slice(0, index)
        .concat(transloc.pendingRequests.slice(index + 1));
      checkIdle();
    },
  };
};



// WEBPACK FOOTER //
// ./src/common/automationUtils.js